import type { DebtAsset } from "~/types/assets.types";

export const calculatePortionFromDebt = (userProduct: DebtAsset) => {
  const routes = userProduct?.routesData || [];
  const totalOriginalSum = calculateAllOriginalSums(userProduct);

  return routes.map((route) => {
    const originalSum = route?.originalSum || 0;

    if (Number(totalOriginalSum) === 0) return 0;
    return originalSum / totalOriginalSum;
  });
};

export const calculateAllOriginalSums = (userProduct: DebtAsset) => {
  const routes = userProduct?.routesData || [];

  return routes.reduce((sum, current) => {
    const originalSum = current.originalSum || 0;

    return sum + Number(originalSum);
  }, 0);
};
